<script lang="ts">
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        success: {
            type: Boolean,
            default: true
        },
        header: String,
        successIcon: {
            type: String,
            default: 'mdi mdi-check-circle-outline'
        },
        title: String,
        text: String,
        confirmText: {
            type: String,
            default: 't-ok'
        },
    },
    emits: ['onConfirm', 'update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        }
    },
    methods: {
        confirm() {
            this.dialogShow = false;
            this.$emit('onConfirm')
        },
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="80%" height="50%" :close-on-back="false" persistent>
        <v-card class="big-dialog h-100 px-3">
            <v-toolbar density="compact">
                <v-toolbar-title>{{ header }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon="mdi-close" @click="dialogShow = false"></v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="d-flex flex-column align-center justify-center w-100 h-100 pb-0">
                <v-btn v-if="success" class="ma-2 icon-gradient" variant="text" :readonly="true" size="80">
                    <v-icon :icon="successIcon" size="80"></v-icon>
                </v-btn>
                <v-btn v-if="!success" class="ma-2 icon-gradient" variant="text" :readonly="true" size="80">
                    <v-icon icon="mdi mdi-note-remove-outline" size="80"></v-icon>
                </v-btn>
                <p class="title">{{ title }}</p>
                <span class="text-describe">{{ text }}</span>
            </v-card-text>
            <v-card-actions>
                <v-container class="mx-0">
                    <div class="d-flex justify-end">
                        <v-btn @click="confirm" variant="flat" color="primary" size="large">
                            {{ $t(confirmText) }}
                        </v-btn>
                    </div>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>